import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ISbRichtext } from '@storyblok/js';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { customRenderText, fixHtml } from '../../custom-render-text';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

const calcCustomLineHeight = (size: number) => {
  if (!size) return;
  if (size <= 24) return 1.2;
  if (size <= 48) return 1.2;
  return 1;
};

@Component({
  selector: 'app-title',
  standalone: true,
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BlockWrapperComponent, ReplaceTextPipe, SafeHtmlPipe],
})
export class TitleComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() style: BlockStyle[];
  @Input() size: string;
  @Input() type: string;
  @Input() title: string;
  @Input() titleText: ISbRichtext;
  @Input() alignment: string;
  @Input() fontWeight: string;
  @Input() anchor: string;
  @Input() customLargeDesktopSize: number;
  @Input() customDesktopSize: number;
  @Input() customTabletSize: number;
  @Input() customMobileSize: number;

  @Input() customTextAlign: string;
  @Input() mobileAlignment: string;
  @Input() tabletAlignment: string;
  @Input() desktopAlignment: string;

  customMobileLineHeight: number;
  customTabletLineHeight: number;
  customDesktopLineHeight: number;
  customLargeDesktopLineHeight: number;

  sanitizedTitle: string;

  ngOnChanges() {
    if (this.size === 'custom') {
      this.customMobileLineHeight = calcCustomLineHeight(this.customMobileSize);
      this.customTabletLineHeight = calcCustomLineHeight(this.customTabletSize);
      this.customDesktopLineHeight = calcCustomLineHeight(this.customDesktopSize);
      this.customLargeDesktopLineHeight = calcCustomLineHeight(this.customLargeDesktopSize);
    }

    if (this.titleText) {
      let open = false;
      this.sanitizedTitle = fixHtml(customRenderText(this.titleText)).replace(/<[^>]*>?/gm, (match: string) => {
        if (match === '<span style="color:#4353FF">' || match === '<span style="color:#FB4F4F">') {
          open = true;
          return match;
        }
        if (match === '</span>' && open) {
          open = false;
          return match;
        }
        return '';
      });
    }
  }
}
